import { createFileRoute } from "@tanstack/react-router";
import { OtaUpdatesPage } from "@/components/solutions/OtaFirmwarePage";
import { otaUpdatesSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/solutions/ota-updates")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => otaUpdatesSeo(loaderData?.href ?? "/solutions/ota-updates"),
  component: OtaUpdatesPage,
});
